import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { positions } from 'src/utils/constants';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { setLocation } from 'src/redux/actions/user.actions';


const AccountProfileDetails = (props) => {
  const { user } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.ui);

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    address: '',
    city: '',
    state: '',
    zip_code: '',
    country: 'Philippines'
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };


  const handleSubmit = () => {

      dispatch(setLocation(values))
      .then(() => {


      })
      .catch(err => {

      })
  }





  useEffect(() => {
    
    if(user && user.location){
      setValues(user.location);
    }

  }, [user])


  return (
    <form
      autoComplete="off"
      noValidate
      {...props}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited"
          title="Current Address"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                label="Street Address"
                name="address"
                onChange={handleChange}
                value={values.address}
                variant="outlined"
                size="small"
                helperText="Street/Block/House No./Barangay"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="City"
                name="city"
                onChange={handleChange}
                value={values.city}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                size="small"
                label="State/Province"
                name="state"
                value={values.state}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={values.country}
                variant="outlined"
                size="small"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                size="small"
                label="Zip Code"
                name="zip_code"
                onChange={handleChange}
                value={values.zip_code}
                variant="outlined"
              />
            </Grid>
          
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            disabled={loading}
            onClick={handleSubmit}
          >
            Save details
          </Button>
        </Box>
      </Card>
    </form>
  );
};

export default AccountProfileDetails;
